var React = require('react');

function EmailInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M173.9 177.1a15 15 0 0 1-17.8 0L30 84.6l-30-22V275a15 15 0 0 0 15 15h300a15 15 0 0 0 15-15V62.6l-30 22-126.1 92.5z","key":0}),React.createElement("path",{"d":"M165 146.4 310.1 40H19.9z","key":1})]);
}

EmailInline.defaultProps = {"xmlSpace":"preserve","viewBox":"0 0 330 330","width":"50","height":"50","fill":"white"};

module.exports = EmailInline;

EmailInline.default = EmailInline;
